<a [href]="url" class="signup-link" title="{{ action }} with LinkedIn">
  <img
    src="/assets/images/linkedin_logo.svg"
    alt="{{ action }} with LinkedIn"
  />
</a>
